import React, { useEffect, useState } from "react";
// FIX: Removed unused NavLink import.
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import { format } from "date-fns";
import RegisterForm from "./RegisterForm-workable";




const EventsDetails = () => {

  
useEffect(() => {
    // Check URL hash
    if (window.location.hash) {
      const elementId = window.location.hash.replace("#", "");
      const element = document.getElementById(elementId);

      if (element) {
        // Smooth scroll to the element
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 200); // small delay to ensure DOM is ready
      }
    }
  }, []);
  
  

  const title = "Event Details";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.1,
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };

  const formatDate = (date) => {
    if (!date) return "";
    try {
      const parsedDate = typeof date === "string" ? new Date(date) : date;
      return format(parsedDate, "dd MMMM yyyy");
    } catch {
      return date;
    }
  };



  return (
    <>
      <Helmet>
        <title>Event Details | MSB Association</title>
        {/* For SEO, we'll strip HTML from the description */}
        
        <meta property="og:title" content="Events Details | MSB Association" />
      
        <meta
          property="og:image"
          content="https://msbassociationuk.org/assets/images/logo.svg"
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <section className="page_header text-center section_decoration overflow-hidden eventbg-image-css">
        <div className="container">
          <motion.h1
            className="page_title text-white"
            initial="hidden"
            animate="visible"
            style={{ display: "flex", justifyContent: "center" }}
          >
            {title.split("").map((letter, index) => (
              <motion.span
                key={index}
                custom={index}
                variants={letterVariants}
                style={{
                  display: "inline-block",
                  marginRight: letter === " " ? "0.3rem" : "0",
                  whiteSpace: "pre",
                }}
              >
                {letter}
              </motion.span>
            ))}
          </motion.h1>
        </div>
      </section>

      <section className="contact_section section_space" style={{scrollBehavior: "smooth"}}>
        <div className="container">
          <div className="item_details_content p-3">
<div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginTop: "20px",
  }}
>
  <h3>FREE WEBINAR -</h3>
  {/* Title 1 */}
  <div
    style={{
      padding: "16px 20px",
      borderRadius: "12px",
      background: "linear-gradient(90deg, #ddd, #ddd)",
      color: "#111",
      fontSize: "18px",
      fontWeight: "600",
      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
    }}
  >
  HMRC Visit Preparation
  </div>
</div>            <div className="row mt-4 mb-5">
              <div className="col-lg-3 col-md-3 col-12">
                <div className="event-detail-bg mb-1">
                  <img src="assets/images/event-banner/date.svg" alt="Date" />
                
                    <div className="text-white">
                     
                          <span className="fw-bolder">Date</span>
                      <h6 className="fw-bold mb-1 text-white lh-base">Friday, 13th March 2026</h6>
                  
                    </div>
             
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-12">
                <div className="event-detail-bg mb-1">
                  <img src="assets/images/event-banner/time.svg" alt="Time" />
                  
                    <div className="text-white">
                    
                        <span className="fw-bolder">Time</span>
                    
                      <h5 className="fw-bold mb-1 text-white">1 PM GMT</h5>
                    </div>
             
                </div>
              </div>
               <div className="col-lg-3 col-md-3 col-12">
                <div className="event-detail-bg mb-1">
                  <img src="assets/images/event-banner/duration.svg" alt="Duration" />
                 
                    <div className="text-white">
                       <span className="fw-bolder">Duration</span>
                   <h5 className="fw-bold mb-1 text-white">60 min</h5>
                    </div>
            
                </div>
              </div>
                <div className="col-lg-3 col-md-3 col-12">
                <div className="event-detail-bg mb-1">
                  <img src="assets/images/event-banner/speaker.svg" alt="Speaker" />
                
                    <div className="text-white">
                       <span className="fw-bolder">Speaker</span>
                   
                        <h6 className="fw-bold mb-1 text-white lh-base" style={{ fontSize: "14px" }}>Mr. Ajinkya Patil, Compliance Manager - Calyx Solutions</h6>
                    </div>
              
                </div>
              </div>
            </div>

            <div className="row mb-4 mt-4 align-items-center">
              <div className="col-lg-6 col-md-6 col-12">
                <div className="schedule-date fw-bold fs-5">
                  Description
                </div>
                <div className="schedule-card">                 
               
                    <div
                      className="schedule-data mb-2">


 <h5><strong>Mr. Ajinkya Patil</strong></h5>
 <p>Join Mr. Ajinkya Patil for a practical and focused webinar designed to help you confidently prepare for an HMRC compliance visit.</p>
 <p>This session is fully focused on HMRC visit preparation, helping business owners clearly understand what HMRC expects during inspections, how to identify potential risk areas in advance, avoid costly compliance mistakes, and strengthen internal controls before a visit takes place.</p>
 
 <p>Compliance gaps can be expensive — but proper preparation gives you confidence and control.</p>
 <p>If your business holds an HMRC licence, this session will help you stay compliant, inspection-ready, and fully prepared.</p>
 
 <h5><strong>What Ajinkya will cover</strong></h5>
 {/* <b>HMRC Visit Preparation – Protect Your Business</b> */}
 <ul>
   <li>Why HMRC conducts inspections</li>
   <li>Common triggers that lead to compliance visits</li>
   <li>Core records and systems you must maintain</li>
   <li>Preparing your premises and staff for inspection</li>
   <li>What typically happens during a visit</li>
   <li>Post-visit actions and responding to HMRC findings</li>
   <li>Practical steps to reduce compliance risk</li>
 </ul>
 <br />
 <p>This session is designed to help you move from basic compliance to being fully inspection-ready.</p>

                      </div>
             
                </div>
              </div>

              <hr className="d-block d-sm-none" />

              <div className="col-lg-6 col-md-6 col-12">
              
                  <img
                    src="/assets/images/event-banner/Webnair-03-march.png"
                    alt="Event"
                    className="img-fluid rounded-2"
                  />
            
              </div>
            </div>
          </div>
          {/* <RegisterForm /> */}
          <RegisterForm/>
        </div>
      </section>
    </>
  );
};

export default EventsDetails;